import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('xlook_cart');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });
  const [wishlist, setWishlist] = useState(() => {
    try {
      const saved = localStorage.getItem('xlook_wishlist');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });
  const [currency, setCurrency] = useState(() => localStorage.getItem('xlook_currency') || 'USD');
  const [language, setLanguage] = useState(() => localStorage.getItem('xlook_language') || 'English');

  useEffect(() => { localStorage.setItem('xlook_cart', JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem('xlook_wishlist', JSON.stringify(wishlist)); }, [wishlist]);
  useEffect(() => { localStorage.setItem('xlook_currency', currency); }, [currency]);
  useEffect(() => { localStorage.setItem('xlook_language', language); }, [language]);

  const addToCart = (item) => {
    setCart((prev) => {
      const existing = prev.find((p) => p.id === item.id && p.packageId === item.packageId);
      if (existing) {
        return prev.map((p) => p === existing ? { ...p, qty: p.qty + (item.qty || 1) } : p);
      }
      return [...prev, { ...item, qty: item.qty || 1 }];
    });
  };
  const removeFromCart = (id, packageId) => setCart((prev) => prev.filter((p) => !(p.id === id && p.packageId === packageId)));
  const updateQty = (id, packageId, qty) => setCart((prev) => prev.map((p) => (p.id === id && p.packageId === packageId) ? { ...p, qty: Math.max(1, qty) } : p));
  const clearCart = () => setCart([]);

  const toggleWishlist = (id) => {
    setWishlist((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  return (
    <AppContext.Provider value={{ cart, addToCart, removeFromCart, updateQty, clearCart, wishlist, toggleWishlist, currency, setCurrency, language, setLanguage }}>
      {children}
    </AppContext.Provider>
  );
};
